// extracted by mini-css-extract-plugin
export default {"Heading":"E3lyE2pUr4JODpEYbHMe","Description":"vyo8UTe2MiSR4m0iLBYR","Alert":"rWx_83oChqBoukpvdK1A"};